<template>
    <b-dropdown
            right
            menu-class="dropdown-menu-lg p-0"
            toggle-class="header-item noti-icon"
            variant="black"
    >
        <template v-slot:button-content>
            <!--            <i class="bx bx-bell bx-tada"></i>-->
            <i class="bx bx-bell"></i>
            <span class="badge badge-danger badge-pill" v-if="unreadNotifications.length">
                {{ unreadNotifications.length }}
            </span>
        </template>

        <div class="p-3">
            <div class="row align-items-center">
                <div class="col">
                    <h6 class="m-0">
                        {{ $t("navbar.dropdown.notification.text") }}
                    </h6>
                </div>
                <div class="col-auto">
                    <router-link to="/notifications" class="small">View archived</router-link>
                    <a v-if="notifications && notifications.length" href="#" @click="clearNotifications" class="small ml-3">Clear all</a>
                </div>
            </div>
        </div>
        <simplebar style="max-height: 230px">
            <a v-for="notification in notifications" v-if="!isLoading"
               @click="navigateToNotificationAndMarkAsRead(notification)"
               href="#" class="text-reset notification-item">
                <div class="media">
                    <div class="avatar-xs mr-3">
                                  <span v-if="isNotificationRead(notification)"
                                        class="avatar-title bg-success rounded-circle font-size-16">
                                    <i class="bx bx-check"></i>
                                  </span>
                        <span v-else class="avatar-title bg-primary rounded-circle font-size-16">
                                    <i class="bx bx-bell"></i>
                                  </span>
                    </div>
                    <div class="media-body">
                        <h6 class="mt-0 mb-1">
                            {{ notification.data.subject }}
                        </h6>
                        <div class="font-size-12 text-muted">
                            <p class="mb-1">
                                {{ notification.data.body }}
                            </p>
                            <p class="mb-0">
                                <i class="mdi mdi-clock-outline"></i>
                                {{ notificationTimestamp(notification) }}
                            </p>
                        </div>
                    </div>
                </div>
            </a>
            <div class="mx-3 alert alert-info" v-if="!isLoading && notifications && notifications.length === 0">
                No notifications to show
            </div>
            <div class="text-center pb-4" v-if="isLoading">
                <b-spinner small></b-spinner>
            </div>
        </simplebar>
    </b-dropdown>
</template>

<script>
    import Forms from "../../mixins/Forms";
    import simplebar from "simplebar-vue";
    import axios from 'axios';

    export default {
        name: "Notifications",
        data() {
            return {
                isLoading: false,
                notifications: localStorage.getItem('notifications') !== null ? JSON.parse(localStorage.getItem('notifications')) : []
            }
        },
        created() {
            this.loadNotifications();
        },
        computed: {
            unreadNotifications() {
                return _.filter(this.notifications, notification => {
                    return notification.read_at == null;
                })
            }
        },
        components: {simplebar},
        mixins: [Forms],
        methods: {
            loadNotifications() {
                let vm = this;
                vm.isLoading = true;
                axios.get(API_BASE + '/notifications').then(r => {
                    vm.isLoading = false;
                    vm.notifications = r.data;
                    localStorage.setItem('notifications', JSON.stringify(r.data));
                }).catch(e => {
                    vm.isLoading = false;
                    console.log(e);
                    vm.notifyErrors(e);
                });
            },

            isNotificationRead(notification) {
                return notification.read_at !== null;
            },

            notificationTimestamp(notification) {
                let dateTimeMoment = moment.utc(notification.created_at, 'YYYY-MM-DDTHH:mm:ssZ').tz(window.itgTimezone);
                return dateTimeMoment.fromNow();
            },

            clearNotifications() {
                let vm = this;
                vm.isLoading = true;
                axios.post(API_BASE + '/notifications/clear-all').then(r => {
                    vm.loadNotifications();
                }).catch(e => {
                    console.log(e);
                    vm.notifyErrors(e);
                    vm.isLoading = false;
                });
            },

            navigateToNotificationAndMarkAsRead(notification) {
                let vm = this;
                vm.isLoading = true;
                axios.post(API_BASE + '/notifications/' + notification.id + '/mark-as-read').then(r => {
                    vm.loadNotifications();
                    vm.$router.push(notification.data.url);
                }).catch(e => {
                    console.log(e);
                    vm.notifyErrors(e);
                    vm.isLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
